// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"b7983b4a","142":"acfb6cac","251":"504f21a0","385":"c22aa7da","388":"d12ee84c","620":"cd83087c","630":"fb314a25","758":"210308ae"}[chunkId] + ".chunk.js";
};